import { connect } from 'react-redux';

import { AuthActions } from '../../redux/auth';
import Redirect from './Redirect';

const mapStateToProps = ({ auth }) => {
  return {
    redirectUrl: auth.redirectUrl,
  };
};

const mapDispatchToProps = (dispatch) => ({ clearRedirectUrl: () => dispatch(AuthActions.clearRedirectUrl()) });

export default connect(mapStateToProps, mapDispatchToProps)(Redirect);
